import { Reveal } from "@/components/Reveal";
import { Mandala } from "@/components/Mandala";
import { Ambient } from "@/components/Ambient";

/* Shared editorial section heading */
export const SectionHeader = ({ eyebrow, title, dark = false, align = "left" }) => (
    <Reveal className={align === "center" ? "text-center" : ""}>
        <p className={`eyebrow ${dark ? "" : "eyebrow--dark"}`} data-testid={`eyebrow-${eyebrow.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{eyebrow}</p>
        <hr className={`gold-rule mt-4 ${align === "center" ? "gold-rule--center mx-auto" : ""}`} aria-hidden="true" />
        <h2
            className={`font-display mt-5 text-4xl font-semibold leading-[1.12] sm:text-5xl ${
                dark ? "text-[#FFF5E6]" : "text-[#260910]"
            }`}
        >
            {title}
        </h2>
    </Reveal>
);

/* Inner-page hero band — atmospheric but compact */
export const PageHero = ({ eyebrow, title, intro, children }) => (
    <section className="surface-maroon relative overflow-hidden pb-16 pt-36 sm:pb-20 sm:pt-44">
        <Mandala className="absolute -right-40 -top-40 h-[480px] w-[480px] opacity-40" />
        <Ambient />
        <div className="relative mx-auto max-w-4xl px-5 sm:px-8">
            <Reveal>
                <p className="eyebrow">{eyebrow}</p>
                <hr className="gold-rule mt-4" aria-hidden="true" />
                <h1 className="font-display mt-5 text-4xl font-semibold leading-[1.1] text-[#FFF5E6] sm:text-5xl lg:text-6xl">
                    {title}
                </h1>
                {intro && (
                    <p className="body-copy mt-6 max-w-2xl text-[#FFF5E6]/75">{intro}</p>
                )}
                {children}
            </Reveal>
        </div>
    </section>
);
